import React from "react";
import { useFormikContext } from "formik";
import { LuRefreshCcw } from "react-icons/lu";
import { usePageSettings } from "../../../../contexts/PageSettingsContext";
import { useCheckout } from "../../../../contexts/CheckoutPageContext";

const TabTitle = ({ title = "Configurar servidor", subtitle = "Elige las especificaciones de tu servidor." }) => {
	const { resetForm, validateForm, setTouched, values } = useFormikContext();
	const { resetOrderCount } = useCheckout();
	const { translations } = usePageSettings();

	const handleReset = async () => {
		resetOrderCount();
		resetForm(); // Resets to initial values

		// Wait for validation to finish
		const errors = await validateForm();

		// Mark all fields that have errors as touched
		const touchedFields = Object.keys(errors).reduce((acc, fieldName) => {
			return { ...acc, [fieldName]: true };
		}, {});

		setTouched(touchedFields);
	};

	return (
		<div className="flex flex-col md:flex-row md:items-center justify-between pt-7 md:pt-24">
			<div className="flex flex-col gap-[6px]">
				<p className="text-zinc-200 text-base font-bold">{translations[title]}</p>
				<div className="flex flex-col md:flex-row md:gap-2">
					<span className="text-zinc-500 text-sm font-normal">{translations[subtitle]}</span>
					<span className="text-ipxon-magenta text-sm font-normal">{translations["TabTitleMandatoryFields"]}</span>
				</div>
			</div>
			{/* Button that calls the resetForm method */}
			<button
				type="button"
				onClick={handleReset}
				className="group pt-2 md:justify-center md:items-center gap-2 inline-flex opacity-80 hover:opacity-100"
			>
				<span className="text-neutral-50 text-xs font-bold">{translations["TabTitleRefreshButton"]}</span>
				<LuRefreshCcw className="group-hover:rotate-180 duration-300 transition-all " />
			</button>
		</div>
	);
};

export default TabTitle;
